import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

// ----- Sentry error tracking ------------------------------------------------
// Initialise as early as possible — before React renders — so even crashes in
// the top-level component get captured. Silent no-op if REACT_APP_SENTRY_DSN
// isn't set (local dev stays clean).
const _SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (_SENTRY_DSN) {
  Sentry.init({
    dsn: _SENTRY_DSN,
    // Bewusst OHNE Sitzungs-Aufzeichnung (Replay): die würde Klicks und Eingaben mitschneiden,
    // das ist rechtlich heikel (16.10.2026). Nur Fehlermeldungen.
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Only 5% of pageloads get a full trace — keeps us inside the free quota.
    tracesSampleRate: 0.05,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_RELEASE_SHA,
  });
}
// ---------------------------------------------------------------------------

// ---- Self-hosted fonts (DSGVO-konform) ----------------------------------
// Replaces the previous `@import url('https://fonts.googleapis.com/…')` calls
// that leaked the visitor's IP to Google on every page load (LG München I,
// 20.01.2022 — Google-Fonts-from-google-servers ≡ DSGVO-Verstoß).
// @fontsource serves the same files from our own bundle; no third-party
// request, no consent required, also slightly faster (no extra DNS+TLS).
import "@fontsource/syne/700.css";
import "@fontsource/syne/800.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/inter/900.css";
import "@fontsource/space-mono/400.css";
import "@fontsource/space-mono/700.css";
import "@fontsource/playfair-display/500-italic.css";

import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
